module.exports = __webpack_public_path__ + "img/xt1@2x.01dbc888.png";